import React, { useState } from 'react';
// If using react-router-dom in a full application, you would import useNavigate like this:
// import { useNavigate } from 'react-router-dom'; // Uncommented for demonstration

// CSS Styles moved outside the component to avoid "Objects are not valid as a React child" error
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

    body {
        font-family: 'Inter', sans-serif;
        margin: 0;
        background-color: #f3f4f6;
    }

    .top-nav-container {
      min-height: fit-content;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding: 0;
    }

    .main-content-wrapper {
      width: 100%;
      max-width: 100%;
      background-color: white;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      border-radius: 0;
      /* Removed overflow: hidden; to ensure profile menu is not clipped */
      display: flex;
      flex-direction: column;
      border-bottom: none;
    }

    .top-nav-row-one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.5rem;
      border-bottom: none;
    }

    .search-box {
      display: flex;
      align-items: center;
      background-color: #f9fafb;
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
      color: #6b7280;
      width: 100%;
      max-width: 20rem;
    }

    @media (min-width: 640px) {
      .search-box {
        width: 20rem;
      }
    }

    @media (min-width: 768px) {
      .search-box {
        width: 24rem;
      }
    }

    .search-icon {
      height: 1.25rem;
      width: 1.25rem;
      margin-right: 0.5rem;
      color: #6b7280;
    }

    .search-input {
      border: none;
      background: transparent;
      flex-grow: 1;
      outline: none;
      font-size: 0.875rem;
      color: #374151;
    }

    .search-input::placeholder {
      color: #9ca3af;
    }

    .bell-profile-group {
      display: flex;
      align-items: center;
      gap: 1.25rem;
      margin-left: auto;
      position: relative;
    }

    .bell-icon {
      height: 1.5rem;
      width: 1.5rem;
      color: #4b5563;
      cursor: pointer;
      transition: color 0.2s ease-in-out;
    }

    .bell-icon:hover {
      color: #1f2937;
    }

    .profile-pic {
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #d1d5db;
      cursor: pointer;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    }

    .profile-menu {
      position: absolute;
      top: calc(100% + 10px);
      right: 0;
      background-color: white;
      border-radius: 0.5rem;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      padding: 0.75rem 0;
      z-index: 9999; /* Increased z-index significantly for guaranteed top view */
      min-width: 150px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      transform-origin: top right;
      animation: fadeInScale 0.2s ease-out;
    }

    @keyframes fadeInScale {
      from {
        opacity: 0;
        transform: scale(0.95);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }

    .profile-menu-username {
        font-weight: 600;
        padding: 0.5rem 1rem;
        color: #1f2937;
        font-size: 0.9rem;
        margin-bottom: 0.5rem;
        width: calc(100% - 2rem);
        word-break: break-word;
    }

    .profile-menu-logout-btn {
        width: calc(100% - 2rem);
        padding: 0.75rem 1rem;
        background-color: #f87171;
        color: white;
        border: none;
        border-radius: 8px;
        font-size: 0.875rem;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out;
        margin: 0 1rem 0.5rem;
    }

    .profile-menu-logout-btn:hover {
        background-color: #ef4444;
    }

    .top-nav-row-two {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.5rem;
      flex-wrap: wrap;
    }

    .date-text {
      color: #4b5563;
      font-size: 0.875rem;
      font-weight: 500;
      white-space: nowrap;
      flex-grow: 1;
      text-align: center;
    }

    @media (max-width: 639px) {
        .top-nav-row-two {
            flex-direction: column;
            align-items: center;
            gap: 0.75rem;
        }
        .date-text {
            text-align: center;
            flex-grow: 0;
        }
    }

    .booking-btn {
      background-color: #AE7D54;
      color: white;
      padding: 0.5rem 1.25rem;
      border: none;
      border-radius: 0.5rem;
      font-size: 0.875rem;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.2s ease-in-out;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    }

    .booking-btn:hover {
      background-color: #946746;
    }

    /* Message Box Styles */
    .message-box {
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #4CAF50;
      color: white;
      padding: 15px 25px;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      z-index: 1000;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    }

    .message-box.show {
      opacity: 1;
      visibility: visible;
    }

    .message-box.error {
        background-color: #f44336;
    }

    /* Booking Form Styles */
    .booking-form-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000; /* Above everything else */
    }

    .booking-form-container {
        background-color: white;
        padding: 2rem;
        border-radius: 0.75rem;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        width: 90%;
        max-width: 700px; /* Increased max-width for two columns */
        max-height: 90vh; /* Limit height for scrollability */
        overflow-y: auto; /* Enable scrolling for long forms */
        position: relative;
    }

    .booking-form-container h2 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 1.5rem;
        text-align: center;
    }

    .form-grid {
        display: grid;
        grid-template-columns: 1fr; /* Default to single column on small screens */
        gap: 1rem; /* Gap between form groups */
    }

    @media (min-width: 600px) { /* Two columns on screens wider than 600px */
        .form-grid {
            grid-template-columns: 1fr 1fr;
        }
    }

    .form-group {
        margin-bottom: 0; /* Remove margin-bottom from individual groups as grid handles spacing */
    }

    .form-group label {
        display: block;
        font-size: 0.875rem;
        font-weight: 500;
        color: #374151;
        margin-bottom: 0.5rem;
    }

    .form-group input,
    .form-group select,
    .form-group textarea {
        width: 100%;
        padding: 0.75rem;
        border: 1px solid #d1d5db;
        border-radius: 0.5rem;
        font-size: 1rem;
        color: #374151;
        outline: none;
        transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    }

    .form-group input:focus,
    .form-group select:focus,
    .form-group textarea:focus {
        border-color: #AE7D54;
        box-shadow: 0 0 0 2px rgba(174, 125, 84, 0.2);
    }

    .form-group textarea {
        min-height: 80px;
        resize: vertical;
    }

    /* Make special request textarea span two columns */
    .form-group.full-width {
        grid-column: 1 / -1; /* Span all columns */
    }

    .form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
        grid-column: 1 / -1; /* Ensure buttons span full width in grid */
    }

    .form-actions button {
        padding: 0.75rem 1.5rem;
        border: none;
        border-radius: 0.5rem;
        font-size: 1rem;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out, opacity 0.2s ease-in-out;
    }

    .form-actions .submit-btn {
        background-color: #AE7D54;
        color: white;
    }

    .form-actions .submit-btn:hover {
        background-color: #946746;
    }

    .form-actions .cancel-btn {
        background-color: #e5e7eb;
        color: #374151;
    }

    .form-actions .cancel-btn:hover {
        background-color: #d1d5db;
    }

    /* Responsive adjustments for form */
    @media (max-width: 500px) {
        .booking-form-container {
            padding: 1.5rem;
        }
        .booking-form-container h2 {
            font-size: 1.25rem;
        }
        .form-actions {
            flex-direction: column;
            gap: 0.75rem;
        }
        .form-actions button {
            width: 100%;
        }
    }
  `}</style>
);


const App = () => {
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const profilePicPlaceholder = "https://placehold.co/32x32/AE7D54/ffffff?text=User";

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  // Using a placeholder for loggedInUser state.
  // In a real scenario with your XAMPP backend, this would be set after a successful API login.
  const [loggedInUser, setLoggedInUser] = useState({ username: 'Admin User' }); // Default to logged in for demonstration
  const [message, setMessage] = useState('');
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false); // State for booking form visibility

  // State for form fields
  const [bookingDetails, setBookingDetails] = useState({
    name: '',
    phoneNumber: '',
    checkInDateTime: '',
    checkOutDateTime: '',
    numberOfGuests: 1,
    roomType: 'Standard',
    mealPlan: 'Continental Plan (inc. Breakfast)', // Set default to the first new option
    status: 'New', // Set default to the first new option
    specialRequest: '',
  });

  const handleProfileClick = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  const showCustomMessage = (msg, isError = false) => {
    setMessage(msg);
    setShowMessageBox(true);
    setTimeout(() => {
      setShowMessageBox(false);
      setMessage('');
    }, 3000); // Message box disappears after 3 seconds
  };

  const handleLogout = () => {
    // This now simulates a client-side logout by clearing the user state.
    // In a real application with your XAMPP backend, you would send a request
    // to your backend to invalidate the session/token and then clear this state.
    setLoggedInUser(null); // Clear the logged-in user
    showCustomMessage("Logged out successfully!");
    setShowProfileMenu(false); // Close menu after logout
  };

  const handleCreateBookingClick = () => {
    setShowBookingForm(true); // Show the booking form
  };

  const handleCloseBookingForm = () => {
    setShowBookingForm(false); // Hide the booking form
    // Optionally reset form fields
    setBookingDetails({
      name: '',
      phoneNumber: '',
      checkInDateTime: '',
      checkOutDateTime: '',
      numberOfGuests: 1,
      roomType: 'Standard',
      mealPlan: 'Continental Plan (inc. Breakfast)',
      status: 'New',
      specialRequest: '',
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setBookingDetails(prevDetails => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();

    // Map the camelCase state keys to snake_case for the API payload
    const payload = {
      name: bookingDetails.name,
      phone: bookingDetails.phoneNumber,
      check_in: bookingDetails.checkInDateTime,
      check_out: bookingDetails.checkOutDateTime,
      guests: parseInt(bookingDetails.numberOfGuests, 10), // Ensure guests is a number
      meal_plan: bookingDetails.mealPlan,
      room_type: bookingDetails.roomType,
      special_request: bookingDetails.specialRequest,
      status: bookingDetails.status,
    };

    try {
      const response = await fetch('https://admin.thepridehotel.in/api/hotel_bookings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Booking Submitted Successfully:', result);
        showCustomMessage("Booking request submitted successfully!");
        handleCloseBookingForm(); // Close form after successful submission
      } else {
        const errorData = await response.json();
        console.error('Error submitting booking:', response.status, errorData);
        showCustomMessage(`Error: ${errorData.message || 'Failed to submit booking'}`, true);
      }
    } catch (error) {
      console.error('Network error or unexpected issue:', error);
      showCustomMessage("Error: Could not connect to the server. Please ensure your XAMPP server is running.", true);
    }
  };

  return (
    <>
      {/* Global CSS Styles injected via a component */}
      <GlobalStyles />

      {/* React Component JSX */}
      <div className="top-nav-container">
        <div className="main-content-wrapper">
          {/* Top Row: Search Box, Bell Icon, Profile Picture */}
          <div className="top-nav-row-one">
            <div className="search-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="search-icon"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
              <input
                type="text"
                placeholder="Search for rooms and offers"
                className="search-input"
              />
            </div>

            <div className="bell-profile-group">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="bell-icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>
              <img
                src={profilePicPlaceholder}
                alt="User"
                className="profile-pic"
                onClick={handleProfileClick}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://placehold.co/32x32/AE7D54/ffffff?text=Err";
                }}
              />
              {showProfileMenu && (
                <div className="profile-menu">
                  {loggedInUser ? (
                    <>
                      <span className="profile-menu-username">Welcome, {loggedInUser.username}</span>
                      <button className="profile-menu-logout-btn" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  ) : (
                    <span className="profile-menu-username">User not logged in</span>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Bottom Row: Date and Create Booking Button */}
          <div className="top-nav-row-two">
            <span className="date-text">
              {today}
            </span>
            <button className="booking-btn" onClick={handleCreateBookingClick}>
              Create booking
            </button>
          </div>
        </div>
      </div>

      {/* Custom Message Box */}
      {showMessageBox && (
        <div className={`message-box ${message.includes('Error') ? 'error' : ''} show`}>
          {message}
        </div>
      )}

      {/* Booking Form Modal */}
      {showBookingForm && (
        <div className="booking-form-overlay">
          <div className="booking-form-container">
            <h2>Create New Booking</h2>
            <form onSubmit={handleBookingSubmit}>
              <div className="form-grid"> {/* New grid container for two columns */}
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={bookingDetails.name}
                    onChange={handleFormChange}
                    required
                    className="rounded-lg"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phoneNumber">Phone Number</label>
                  <input
                    type="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={bookingDetails.phoneNumber}
                    onChange={handleFormChange}
                    required
                    className="rounded-lg"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="checkInDateTime">Check-in Date & Time</label>
                  <input
                    type="datetime-local"
                    id="checkInDateTime"
                    name="checkInDateTime"
                    value={bookingDetails.checkInDateTime}
                    onChange={handleFormChange}
                    required
                    className="rounded-lg"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="checkOutDateTime">Check-out Date & Time</label>
                  <input
                    type="datetime-local"
                    id="checkOutDateTime"
                    name="checkOutDateTime"
                    value={bookingDetails.checkOutDateTime}
                    onChange={handleFormChange}
                    required
                    className="rounded-lg"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="numberOfGuests">Number of Guests</label>
                  <input
                    type="number"
                    id="numberOfGuests"
                    name="numberOfGuests"
                    value={bookingDetails.numberOfGuests}
                    onChange={handleFormChange}
                    min="1"
                    required
                    className="rounded-lg"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="roomType">Room Type</label>
                  <select
                    id="roomType"
                    name="roomType"
                    value={bookingDetails.roomType}
                    onChange={handleFormChange}
                    className="rounded-lg"
                  >
                    <option value="Standard">Standard</option>
                    <option value="Executive">Executive</option>
                    <option value="Family room">Family room</option>
                    <option value="Twin Room">Twin Room</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="mealPlan">Meal Plan</label>
                  <select
                    id="mealPlan"
                    name="mealPlan"
                    value={bookingDetails.mealPlan}
                    onChange={handleFormChange}
                    className="rounded-lg"
                  >
                    <option value="Continental Plan (inc. Breakfast)">Continental Plan (inc. Breakfast)</option>
                    <option value="European Plan (only stay)">European Plan (only stay)</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="status">Status</label>
                  <select
                    id="status"
                    name="status"
                    value={bookingDetails.status}
                    onChange={handleFormChange}
                    className="rounded-lg"
                  >
                    <option value="New">New</option>
                    <option value="Booked">Booked</option>
                    <option value="Checked In">Checked In</option>
                    <option value="Checked Out">Checked Out</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                </div>
                <div className="form-group full-width"> {/* This will span two columns */}
                  <label htmlFor="specialRequest">Special Request</label>
                  <textarea
                    id="specialRequest"
                    name="specialRequest"
                    value={bookingDetails.specialRequest}
                    onChange={handleFormChange}
                    rows="3"
                    className="rounded-lg"
                  ></textarea>
                </div>
              </div> {/* End of form-grid */}
              <div className="form-actions">
                <button type="button" className="cancel-btn rounded-lg" onClick={handleCloseBookingForm}>
                  Cancel
                </button>
                <button type="submit" className="submit-btn rounded-lg">
                  Submit Booking
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default App;
